import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';
const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/user/:userid/Exception',
        name: 'Exception',
        meta: {
            title: 'Exception'
        },
        component: BasicLayout,
        children: [
            {
                path: '403',
                name: '403',
                meta: {
                    title: '403'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('ApplyRole', () =>
                    import('../model/ApplyRole')
                ),
                component: importEnv('Exception/403')
            },
            {
                path: '404',
                name: '404',
                meta: {
                    title: '404'
                },
                component: importEnv('Exception/404')
            }
        ]
    },
    {
        path: '/Exception',
        name: 'Exception',
        meta: {
            title: 'Exception'
        },
        component: BasicLayout,
        children: [
            {
                path: '403',
                name: '403',
                meta: {
                    title: '403',
                    allowNotLogin: true
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('ApplyRole', () =>
                    import('../model/ApplyRole')
                ),
                component: importEnv('Exception/403')
            },
            {
                path: '404',
                name: '404',
                meta: {
                    title: '404',
                    allowNotLogin: true
                },
                component: importEnv('Exception/404')
            },
            {
                path: 'noAgentAuth',
                name: 'noAgentAuth',
                meta: {
                    title: '无权限',
                    allowNotLogin: true
                },
                component: importEnv('Exception/404')
            }
        ]
    }
];